import {
  ActionType,
  ComparisonValueType,
  ConditionType,
  ElementType,
  FormElement,
  isOptionElement,
} from "@/@types/entities/forms";
import { getTextByCondition, TextByAction } from "@/app/entities/utils/forms/conditionsText";

// IF

const FileConditionOptions = [
  {
    value: ConditionType.IsEmpty,
    label: getTextByCondition(ConditionType.IsEmpty, ElementType.File),
  },
  {
    value: ConditionType.NoEmpty,
    label: getTextByCondition(ConditionType.NoEmpty, ElementType.File),
  },
];

const TextConditionOptions = [
  {
    value: ConditionType.Contains,
    label: getTextByCondition(ConditionType.Contains),
  },
  {
    value: ConditionType.NoContains,
    label: getTextByCondition(ConditionType.NoContains),
  },
  {
    value: ConditionType.BeginsWith,
    label: getTextByCondition(ConditionType.BeginsWith),
  },
  {
    value: ConditionType.NoBeginsWith,
    label: getTextByCondition(ConditionType.NoBeginsWith),
  },
  {
    value: ConditionType.EndsWith,
    label: getTextByCondition(ConditionType.EndsWith),
  },
  {
    value: ConditionType.NoEndsWith,
    label: getTextByCondition(ConditionType.NoEndsWith),
  },
  {
    value: ConditionType.IsEqual,
    label: getTextByCondition(ConditionType.IsEqual),
  },
  {
    value: ConditionType.IsEmpty,
    label: getTextByCondition(ConditionType.IsEmpty),
  },
  {
    value: ConditionType.NoEmpty,
    label: getTextByCondition(ConditionType.NoEmpty),
  },
];

const OptionConditionOptions = [
  {
    value: ConditionType.IsEqual,
    label: getTextByCondition(ConditionType.IsEqual),
  },
  {
    value: ConditionType.NoEqual,
    label: getTextByCondition(ConditionType.NoEqual),
  },
  {
    value: ConditionType.IsEmpty,
    label: getTextByCondition(ConditionType.IsEmpty),
  },
  {
    value: ConditionType.NoEmpty,
    label: getTextByCondition(ConditionType.NoEmpty),
  },
];

const DateTimeConditionOptions = [
  {
    value: ConditionType.IsBefore,
    label: getTextByCondition(ConditionType.IsBefore),
  },
  {
    value: ConditionType.IsAfter,
    label: getTextByCondition(ConditionType.IsAfter),
  },
  {
    value: ConditionType.IsEmpty,
    label: getTextByCondition(ConditionType.IsEmpty),
  },
  {
    value: ConditionType.NoEmpty,
    label: getTextByCondition(ConditionType.NoEmpty),
  },
];

// ELSE

export const ActionOptions = [
  {
    value: ActionType.Hide,
    label: TextByAction[ActionType.Hide],
  },
  {
    value: ActionType.Show,
    label: TextByAction[ActionType.Show],
  },
  {
    value: ActionType.Require,
    label: TextByAction[ActionType.Require],
  },
  {
    value: ActionType.NoRequire,
    label: TextByAction[ActionType.NoRequire],
  },
  {
    value: ActionType.Enable,
    label: TextByAction[ActionType.Enable],
  },
  {
    value: ActionType.Disable,
    label: TextByAction[ActionType.Disable],
  },
];

export function getConditionInputsByElement(formElement?: FormElement) {
  if (!formElement) return;

  const type = formElement.type;

  const isFile = ElementType.File === type;
  const isText = [ElementType.ShortText, ElementType.LongText].includes(type);
  const isOption = [
    ElementType.Dropdown,
    ElementType.MultipleOptions,
    ElementType.SingleOption,
  ].includes(type);
  const isDateTime = [ElementType.Date, ElementType.Hour].includes(type);

  if (isFile)
    return { options: FileConditionOptions, comparisonValueType: ComparisonValueType.File };

  if (isText)
    return { options: TextConditionOptions, comparisonValueType: ComparisonValueType.Text };

  if (isOption && isOptionElement(formElement))
    return {
      options: OptionConditionOptions,
      comparisonValueType: ComparisonValueType.Option,
      valueOptions: formElement.options,
    };

  if (isDateTime) {
    let comparisonValueType = undefined;

    if (ElementType.Date === type) comparisonValueType = ComparisonValueType.Date;

    if (ElementType.Hour === type) comparisonValueType = ComparisonValueType.Time;

    return { options: DateTimeConditionOptions, comparisonValueType };
  }

  return { options: undefined, comparisonValueType: undefined };
}
